module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$vuetify.breakpoint.width <= 768) ? _c('div', {
    staticClass: "QR-page"
  }, [_c('img', {
    staticClass: "ys-logo",
    attrs: {
      "src": "/static/images/landing-page/ys_logo_primary-black.svg"
    }
  }), _vm._v(" "), (this.default && !this.ios && !this.android) ? _c('div', {
    staticClass: "title"
  }, [_vm._v("Download the app "), _c('br'), _vm._v(" to create your account")]) : _vm._e(), _vm._v(" "), (this.default && !this.ios && !this.android) ? _c('div', {
    staticClass: "options"
  }, [_c('div', {
    staticClass: "app-icon-container"
  }, [_c('img', {
    staticClass: "cursor-pointer",
    attrs: {
      "src": "/static/images/landing-page/apple-store.svg",
      "aspect-ratio": "1",
      "height": "84",
      "width": "187"
    },
    on: {
      "click": function($event) {
        _vm.showQR('ios')
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "app-icon-container"
  }, [_c('img', {
    staticClass: "cursor-pointer",
    attrs: {
      "src": "/static/images/landing-page/google-play.svg",
      "aspect-ratio": "1",
      "height": "84",
      "width": "187"
    },
    on: {
      "click": function($event) {
        _vm.showQR('android')
      }
    }
  })])]) : _vm._e(), _vm._v(" "), (this.ios || this.android) ? _c('div', {
    staticClass: "options"
  }, [_c('div', {
    staticClass: "title",
    domProps: {
      "innerHTML": _vm._s(this.ios ? 'Download iOS App' : 'Download Android App')
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "qr-code__content--img",
    staticStyle: {
      "margin-top": "20%",
      "text-align": "center"
    }
  }, [(this.ios) ? _c('img', {
    attrs: {
      "src": require('@/assets/qr/qrcode_ios.png'),
      "width": "307"
    }
  }) : _vm._e(), _vm._v(" "), (this.android) ? _c('img', {
    attrs: {
      "src": require('@/assets/qr/qrcode_android.png'),
      "width": "307"
    }
  }) : _vm._e()])]) : _vm._e(), _vm._v(" "), (this.ios || this.android) ? _c('center', {
    on: {
      "click": _vm.reset
    }
  }, [_vm._v(" Go back ")]) : _vm._e()], 1) : _c('div', [_c('v-container', {
    staticClass: "no-top-nav no-side-space"
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "full-authTabs-wrapper": "",
      "justify-center": "",
      "row": ""
    }
  }, [_c('v-flex', {
    class: {
      onMobileStrict: _vm.onMobileStrict
    },
    attrs: {
      "xs12": ""
    }
  }, [(_vm.activeView === 'signUpView') ? _c('div', {
    staticClass: "signup-view"
  }, [_c('Onboarding')], 1) : _vm._e()])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6dba0e16","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/SignUpPage/index.vue
// module id = 1765
// module chunks = 180